import Button from 'components/Button'
import { useState } from 'react'
import GrileService from 'services/grile-service'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import Tooltip from '@mui/material/Tooltip'
const SubjectCreateButton = ({
  subject,
  onSuccess,
  allowHint,
  setAllowHint,
}) => {
  const [code, setCode] = useState('')
  const handleCreateSubject = async () => {
    GrileService.createSubject(
      subject.map(subject => subject.id),
      code,
      allowHint,
    ).then(res => {
      if (res.error === 'code_error') {
        toast.warn('Există deja un subiect cu acest cod')
      } else {
        toast.success('Subiect creat cu succes')
        onSuccess()
      }
    })
  }
  return (
    <div className="flex flex-col gap-5 px-3">
      <div className="bg-container-background rounded p-5 flex flex-col gap-3">
        <div className="flex gap-2 items-center">
          <input
            type="text"
            name="code"
            className="rounded-[4px] pl-1 text-over-ternary-background bg-container-background border border-brd-primary min-h-8  text-sm text-black"
            placeholder="Introdu codul..."
            onChange={e => setCode(e.target.value)}
            value={code}
          />
          <Tooltip title="Permite indiciul">
            <FontAwesomeIcon
              onClick={() => setAllowHint(prev => !prev)}
              className={`${
                allowHint ? 'text-secondary' : 'text-gray-500'
              } hint-modal cursor-pointer w-[25px] h-[25px] z-[100001]`}
              icon={faLightbulb}
            />
          </Tooltip>
        </div>
        <div className="w-full flex justify-center">
          <Button
            disabled={subject.length === 0 || !code || code.length === 0}
            className="h-8 w-[175px]  bg-btn-primary"
            onClick={handleCreateSubject}
          >
            Crează subiect
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SubjectCreateButton
